import Vue from 'vue'

const projectNote = {
  state: {
    projectNote: [],
    selectedProjectNote: {},
  },

  getters: {
    projectNote(state) {
      return state.projectNote
    },
    selectedProjectNote(state) {
      return state.selectedProjectNote
    },
  },

  mutations: {
    projectNote(state, payload) {
      state.projectNote = payload
    },
    selectedProjectNote(state, payload) {
      state.selectedProjectNote = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedProjectNote(context, payload) {
      context.commit('selectedProjectNote', payload)
    },
    loadProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'ProjectNote'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('projectNote', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'ProjectNote/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedProjectNote', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `ProjectNote/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'project note updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadProjectNote')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `ProjectNote`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'project note created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadProjectNote')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateProjectNote', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createProjectNote', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteProjectNote(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `ProjectNote/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'project note deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadProjectNote')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default projectNote
